import {
  sortConsultationsByDate,
  type TranscriptorConsultation,
} from '@/entities/transcriptor';

import { RECORDINGS_PREVIEW_LIMIT } from '../config';

export const getRecordingsPreview = (
  consultations: TranscriptorConsultation[],
): TranscriptorConsultation[] =>
  sortConsultationsByDate(consultations).slice(0, RECORDINGS_PREVIEW_LIMIT);
